// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".address p[data-v-02376951]{font-size:10pt;margin-bottom:0}.adress-contact[data-v-02376951]{flex-grow:0!important;max-width:265px!important;min-width:265px!important;width:100%!important}@media only screen and (max-width:599px){.adress-contact[data-v-02376951]{max-width:none!important;min-width:0!important;min-width:auto!important}}.gap-3[data-v-02376951]{gap:3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
